const rad = (d) => (Number(d) || 0) * Math.PI / 180;

export default function drawTriangle(g, _app, { origin, settings }) {
  const ppm = Number(settings?.pxPerMeter) || 40;
  const toPx = (m) => Math.max(0, Number(m) || 0) * ppm;

  try { g.lineStyle({ width: 2, color: 0x00d4ff, alpha: 1 }); }
  catch { g.lineStyle(2, 0x00d4ff, 1); }

  const w = Math.max(2, toPx(settings?.width  ?? 2));
  const h = Math.max(2, toPx(settings?.height ?? 2));
  const R = rad(settings?.rotationDeg || 0);

  const A = { x: -w/2, y: 0 }, B = { x: w/2, y: 0 }, C = { x: 0, y: -h };
  const rot = (p) => ({
    x: p.x * Math.cos(R) - p.y * Math.sin(R),
    y: p.x * Math.sin(R) + p.y * Math.cos(R),
  });

  const p0 = { x: origin.x + rot(A).x, y: origin.y + rot(A).y };
  const p1 = { x: origin.x + rot(B).x, y: origin.y + rot(B).y };
  const p2 = { x: origin.x + rot(C).x, y: origin.y + rot(C).y };

  g.moveTo(p0.x, p0.y);
  g.lineTo(p1.x, p1.y);
  g.lineTo(p2.x, p2.y);
  g.lineTo(p0.x, p0.y);
}
